import React, { useEffect, useState } from 'react';
import { styles as st } from './Layout';

function CatalogoSimple({ endpoint, campos }) {
  const vacio = Object.fromEntries(campos.map((c) => [c.key, '']));
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(vacio);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const load = () => fetch(endpoint).then((r) => r.json()).then(setItems);
  useEffect(() => { load(); setForm(vacio); setEditId(null); setShowForm(false); }, [endpoint]); // eslint-disable-line react-hooks/exhaustive-deps

  const guardar = async (e) => {
    e.preventDefault();
    const url = editId ? `${endpoint}/${editId}` : endpoint;
    const method = editId ? 'PUT' : 'POST';
    await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
    setShowForm(false);
    load();
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este registro?')) return;
    const r = await fetch(`${endpoint}/${id}`, { method: 'DELETE' });
    if (!r.ok) { const d = await r.json(); alert(d.error || 'No se pudo eliminar'); return; }
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button style={st.btnAccent} onClick={() => { setForm(vacio); setEditId(null); setShowForm(true); }}>+ Nuevo</button>
      </div>

      {showForm && (
        <form onSubmit={guardar} style={{ marginBottom: 20, borderTop: '1px solid #eee', borderBottom: '1px solid #eee', paddingTop: 16, paddingBottom: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {campos.map((c) => (
              <div key={c.key}>
                <label style={st.label}>{c.label}</label>
                <input style={st.input} type={c.type || 'text'} value={form[c.key] ?? ''} onChange={(e) => setForm({ ...form, [c.key]: e.target.value })} required />
              </div>
            ))}
          </div>
          <div style={{ marginTop: 20 }}>
            <button type="submit" style={st.btnPrimary}>Guardar</button>{' '}
            <button type="button" style={st.btnGhost} onClick={() => setShowForm(false)}>Cancelar</button>
          </div>
        </form>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {campos.map((c) => <th key={c.key} style={st.th}>{c.label}</th>)}
            <th style={st.th}></th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.id}>
              {campos.map((c) => <td key={c.key} style={st.td}>{it[c.key]}</td>)}
              <td style={st.td}>
                <button style={st.btnGhost} onClick={() => { setForm(Object.fromEntries(campos.map((c) => [c.key, it[c.key]]))); setEditId(it.id); setShowForm(true); }}>Editar</button>{' '}
                <button style={st.btnDanger} onClick={() => eliminar(it.id)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function CatalogoAsesores() {
  const endpoint = '/api/catalogos/asesores-inmobiliarios';
  const [items, setItems] = useState([]);
  const [inmobiliarias, setInmobiliarias] = useState([]);
  const vacio = { nombre: '', inmobiliaria_id: '', celular: '' };
  const [form, setForm] = useState(vacio);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const load = async () => {
    const [a, i] = await Promise.all([
      fetch(endpoint).then((r) => r.json()),
      fetch('/api/catalogos/inmobiliarias').then((r) => r.json()),
    ]);
    setItems(a);
    setInmobiliarias(i);
  };
  useEffect(() => { load(); }, []);

  const guardar = async (e) => {
    e.preventDefault();
    const url = editId ? `${endpoint}/${editId}` : endpoint;
    const method = editId ? 'PUT' : 'POST';
    await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
    setShowForm(false);
    load();
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este asesor?')) return;
    const r = await fetch(`${endpoint}/${id}`, { method: 'DELETE' });
    if (!r.ok) { const d = await r.json(); alert(d.error || 'No se pudo eliminar'); return; }
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button style={st.btnAccent} onClick={() => { setForm(vacio); setEditId(null); setShowForm(true); }}>+ Nuevo asesor</button>
      </div>

      {showForm && (
        <form onSubmit={guardar} style={{ marginBottom: 20, borderTop: '1px solid #eee', borderBottom: '1px solid #eee', paddingTop: 16, paddingBottom: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <label style={st.label}>Nombre</label>
              <input style={st.input} value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required />
            </div>
            <div>
              <label style={st.label}>Inmobiliaria</label>
              <select style={st.input} value={form.inmobiliaria_id} onChange={(e) => setForm({ ...form, inmobiliaria_id: e.target.value })} required>
                <option value="">Selecciona…</option>
                {inmobiliarias.map((i) => <option key={i.id} value={i.id}>{i.nombre}</option>)}
              </select>
            </div>
            <div>
              <label style={st.label}>Celular</label>
              <input style={st.input} value={form.celular} onChange={(e) => setForm({ ...form, celular: e.target.value })} />
            </div>
          </div>
          <div style={{ marginTop: 20 }}>
            <button type="submit" style={st.btnPrimary}>Guardar</button>{' '}
            <button type="button" style={st.btnGhost} onClick={() => setShowForm(false)}>Cancelar</button>
          </div>
        </form>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={st.th}>Nombre</th>
            <th style={st.th}>Inmobiliaria</th>
            <th style={st.th}>Celular</th>
            <th style={st.th}></th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.id}>
              <td style={st.td}>{it.nombre}</td>
              <td style={st.td}>{it.inmobiliaria_nombre}</td>
              <td style={st.td}>{it.celular}</td>
              <td style={st.td}>
                <button style={st.btnGhost} onClick={() => { setForm({ nombre: it.nombre, inmobiliaria_id: it.inmobiliaria_id, celular: it.celular || '' }); setEditId(it.id); setShowForm(true); }}>Editar</button>{' '}
                <button style={st.btnDanger} onClick={() => eliminar(it.id)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const TABS = [
  { key: 'inmobiliarias', label: 'Inmobiliarias' },
  { key: 'asesores', label: 'Asesores Inmobiliarios' },
  { key: 'brokers', label: 'Brokers' },
  { key: 'bancos', label: 'Bancos' },
  { key: 'status', label: 'Status de Cliente' },
  { key: 'tipo_credito', label: 'Tipo de Crédito' },
  { key: 'tipo_inmueble', label: 'Tipo de Inmueble' },
];

export default function Catalogos() {
  const [tab, setTab] = useState('inmobiliarias');

  return (
    <div style={st.card}>
      <h2 style={st.sectionTitle}>Catálogos</h2>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20 }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding: '7px 14px', borderRadius: 6, border: '1px solid #1a3a6e', cursor: 'pointer', fontSize: 13, fontWeight: 600,
              backgroundColor: tab === t.key ? '#1a3a6e' : 'white',
              color: tab === t.key ? 'white' : '#1a3a6e',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'inmobiliarias' && <CatalogoSimple endpoint="/api/catalogos/inmobiliarias" campos={[{ key: 'nombre', label: 'Nombre' }]} />}
      {tab === 'asesores' && <CatalogoAsesores />}
      {tab === 'brokers' && <CatalogoSimple endpoint="/api/catalogos/brokers" campos={[{ key: 'nombre', label: 'Nombre' }]} />}
      {tab === 'bancos' && <CatalogoSimple endpoint="/api/catalogos/bancos" campos={[{ key: 'nombre', label: 'Nombre' }]} />}
      {tab === 'status' && <CatalogoSimple endpoint="/api/catalogos/status-cliente" campos={[{ key: 'nombre', label: 'Nombre' }, { key: 'orden', label: 'Orden', type: 'number' }]} />}
      {tab === 'tipo_credito' && <CatalogoSimple endpoint="/api/catalogos/tipo-credito" campos={[{ key: 'nombre', label: 'Nombre' }]} />}
      {tab === 'tipo_inmueble' && <CatalogoSimple endpoint="/api/catalogos/tipo-inmueble" campos={[{ key: 'nombre', label: 'Nombre' }]} />}
    </div>
  );
}
